import React, { FC } from 'react';
import Select, { Props as SelectProps, StylesConfig } from 'react-select';
import styled from 'styled-components';

// Default select components:
import { Option, OptionType } from './Option';
import { SingleValue, TSingleValue } from './SingleValue';
import { DropdownIndicator } from './components/DropdownIndicator';
import { ClearIndicator } from './components/ClearIndicator';
import { Control, IControl } from './CustomControl';
import { NoOptionsMessage } from './components/NoOptionsMessage';

import { ICustomDropdownIndicator } from './CustomComponents.model';

// Styled:
import { getStyles } from './styles';

export interface SearchSelectProps extends Partial<SelectProps> {
  options: any[];

  // Custom Components:
  CustomControl?: IControl;
  CustomOption?: OptionType | null;
  CustomSingleValue?: TSingleValue | null;
  CustomDropdownIndicator?: ICustomDropdownIndicator;
  CustomNoOptionsMessage?: FC<any>;

  customStyles: StylesConfig;

  // Others:
  isMobile?: boolean;
}

export const SearchSelect: FC<SearchSelectProps> = props => {
  const {
    value = { label: '', value: '' },
    defaultValue = { label: '', value: '' },
    isSearchable,
    isClearable,
    options,
    placeholder = 'Выберите...',
    noOptionsMessage = () => 'Не найдено',
    onBlur = () => undefined,
    onFocus = () => undefined,
    filterOption,
    onChange = val => val,
    onInputChange = () => undefined,
    customStyles = {},
    closeMenuOnSelect = true,
    menuIsOpen,
    inputValue,

    CustomControl,
    CustomOption,
    CustomSingleValue,
    CustomDropdownIndicator,
    CustomNoOptionsMessage,

    isMobile = false,
    ...otherProps
  } = props;
  const styles = getStyles(customStyles, isMobile);

  const components = {
    ClearIndicator,
    DropdownIndicator: CustomDropdownIndicator || DropdownIndicator,
    IndicatorSeparator: () => null,
    Option: CustomOption || Option,
    SingleValue: CustomSingleValue || SingleValue,
    NoOptionsMessage: CustomNoOptionsMessage || NoOptionsMessage,
    Control: CustomControl || Control,
  } as any;

  return (
    <StyledSelect
      // Values:
      defaultValue={defaultValue}
      value={value}
      // Flags:
      isSearchable={isSearchable}
      isClearable={isClearable}
      closeMenuOnSelect={closeMenuOnSelect}
      // Options:
      options={options}
      noOptionsMessage={noOptionsMessage}
      filterOption={filterOption}
      // Custom styled and components:
      styles={styles}
      components={components}
      placeholder={placeholder}
      // Controlled input:
      menuIsOpen={menuIsOpen}
      onFocus={onFocus}
      onChange={onChange}
      onBlur={onBlur}
      inputValue={inputValue}
      onInputChange={onInputChange}
      classNamePrefix="react-select"
      {...otherProps}
    />
  );
};

const StyledSelect = styled(Select)`
  width: 100%;
`;
